import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import * as authService from "../../services/auth";
import withSnackbarWrapper from "../common/withSnackbarWrapper";
import { Link } from "react-router-dom";
import withRouter from "./withRouter";

class Login extends Form {
  state = {
    data: { email: "", password: "" },
    errors: {},
  };

  schema = {
    email: Joi.string().required().label("Email"),
    password: Joi.string().required().label("Password"),
  };

  componentDidMount() {
    // Ensure state is properly initialized
    this.setState({ data: { email: "", password: "" }, errors: {} });
  }

  componentDidUpdate(prevProps) {
    // Reset state when location changes
    if (this.props.location !== prevProps.location) {
      this.setState({ data: { email: "", password: "" }, errors: {} });
    }
  }

  doSubmit = () => {
    authService
      .login(this.state.data)
      .then((response) => {
        if (response.success) {
          localStorage.setItem("user", response.data.user);
          localStorage.setItem("isCustomer", response.data.isCustomer);
          this.props.useSnackbarCustom.enqueueSnackbar(
            "Successfully logged in",
            {
              variant: "success",
            }
          );
          window.location.href = "/";
          // const { state } = this.props.location;
          // const from = state?.from?.pathname || "/";
          // this.props.navigate(from, { replace: true });
        } else {
          this.props.useSnackbarCustom.enqueueSnackbar(response.message, {
            variant: "warning",
          });
        }
      })
      .catch((err) => {
        console.log("Some error occurred.", err);
        this.props.useSnackbarCustom.enqueueSnackbar(err.response.data.errors, {
          variant: "error",
        });
      });
  };

  render() {
    return (
      <div className="container mt-5">
        <h1>Sign in to access Vocal Results Studio®</h1>
        <form onSubmit={this.handleSubmit} className="mt-5">
          {this.renderInput("email", "Email", "email")}
          {this.renderInput("password", "Password", "password", {
            autoComplete: "off",
          })}
          <div className="form-group">
            <div className="form-check d-flex p-0">
              <span className="form-other-redirect">
                Not a member yet? Register <Link to="/register">here</Link>
              </span>
              <span className="form-other-redirect">
                <a href="/forgotPassword">Forgot password?</a>
              </span>
            </div>
          </div>
          {this.renderButton("Login")}
        </form>
      </div>
    );
  }
}

export default withRouter(withSnackbarWrapper(Login));
